import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export const TeamSection = () => {
  const navigate = useNavigate();

  return (
    <section
      className="light-section"
      style={{ padding: 0, alignItems: "flex-end", position: "relative" }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/assets/imagenes/home/equipo.png`}
        className="imagen-equipo"
        alt="equipo"
      />
      <img
        src={`${process.env.PUBLIC_URL}/assets/imagenes/home/img_equipo.png`}
        alt="linea-estrella"
        className="imagen-estrella"
      />

      <img
        src={`${process.env.PUBLIC_URL}/assets/imagenes/home/corazonequipo.png`}
        className="imagen-corazon"
        alt="corazon"
      />
      <div className="descripcion-equipo-wrapper">
        <div className="descripcion-equipo-layout">
          <span className="descripcion-equipo-item">
            <span className="horizontal gap-8">
              <img
                alt="años"
                className="iconos-quienes-somos"
                src={`${process.env.PUBLIC_URL}/assets/imagenes/home/quienes-somos/iconos-quienesomos-26.png`}
              />
              <p className="equipo-item-title">+15 años</p>
            </span>
            <span className="equipo-item-subtitle">
              Creación <br />
              de binamics
            </span>
          </span>
          <span className="descripcion-equipo-item">
            <span className="horizontal gap-8">
              <img
                alt="años"
                className="iconos-quienes-somos"
                src={`${process.env.PUBLIC_URL}/assets/imagenes/home/quienes-somos/iconos-quienesomos-24.png`}
              />
              <p className="equipo-item-title">27 años</p>
            </span>
            <span className="equipo-item-subtitle">
              Experiencia <br />
              en el Agro
            </span>
          </span>
          <span className="descripcion-equipo-item">
            <span className="horizontal gap-8">
              <img
                alt="años"
                className="iconos-quienes-somos"
                src={`${process.env.PUBLIC_URL}/assets/imagenes/home/quienes-somos/iconos-quienesomos-23.png`}
              />
              <p className="equipo-item-title">4.7</p>
            </span>
            <span className="equipo-item-subtitle">
              Calificación <br />
              de Clientes
            </span>
          </span>
          <span className="descripcion-equipo-item">
            <span className="horizontal gap-8">
              <img
                alt="años"
                className="iconos-quienes-somos"
                src={`${process.env.PUBLIC_URL}/assets/imagenes/home/quienes-somos/iconos-quienesomos-25.png`}
              />
              <p className="equipo-item-title">+50</p>
            </span>
            <span className="equipo-item-subtitle">
              Clientes <br />
              Activos
            </span>
          </span>
        </div>
        <div className="horizontal gap-16" style={{ marginTop: "2rem" }}>
          <button
            className="boton-generico boton-blanco"
            onClick={() => navigate("/about")}
            style={{ marginRight: "auto" }}
          >
            <p>Más sobre nosotros</p>
            <FaArrowRight />
          </button>
          <a
            download
            href="https://binamics.com.ar/brochures/presentacion_empresarial_binamics.pdf"
            style={{ textDecoration: "none" }}
            target="_blank"
            rel="noreferrer"
          >
            <button className="boton-generico boton-blanco">
              <p>Descargar PDF institucional</p>
              <FaArrowRight />
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};
